var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import SidebarPageSider from '@hellodarwin/core/lib/components/common/layout/sidebar-page-layout/sidebar-page-sider';
import { SidebarPageBody, SidebarPageContent, } from '@hellodarwin/core/lib/components/common/layout/sidebar-page-layout/styles';
import Div from '@hellodarwin/core/lib/components/common/div';
import { useAppData } from '@hellodarwin/core/lib/features/providers/app-data-provider';
import { useBreadcrumbs } from '@hellodarwin/core/lib/features/providers/breadcrumbs-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import PageContainer from '../page-layout/components/PageContainer';
import PremiumFeatureOverlay from '../premium-access/components/premium-paywall-overlay';
const SidebarPageLayoutV2 = (_a) => {
    var _b;
    var { tabTitle, styles, children, className, leftSidebarBlocks = [], rightSidebarBlocks = [], defaultNavCollapsed = false, defaultLeftSidebarCollapsed = false, defaultRightSidebarCollapsed = false, noFooter, underSearch, actions, onSidebarChange, breadcrumbs } = _a, appHeaderProps = __rest(_a, ["tabTitle", "styles", "children", "className", "leftSidebarBlocks", "rightSidebarBlocks", "defaultNavCollapsed", "defaultLeftSidebarCollapsed", "defaultRightSidebarCollapsed", "noFooter", "underSearch", "actions", "onSidebarChange", "breadcrumbs"]);
    const { title, app } = appHeaderProps;
    const { setBreadCrumbs } = useBreadcrumbs();
    useEffect(() => {
        setBreadCrumbs(breadcrumbs);
    }, [breadcrumbs]);
    const { t } = useTranslations();
    const theme = useTheme();
    const { setNavCollapsed } = useAppData();
    const [leftNavCollapsed, setLeftNavCollapsed] = useState(defaultLeftSidebarCollapsed);
    const [rightNavCollapsed, setRightNavCollapsed] = useState(defaultRightSidebarCollapsed);
    const handleLeftNavCollapsed = () => setLeftNavCollapsed(!leftNavCollapsed);
    const handleRightNavCollapsed = () => setRightNavCollapsed(!rightNavCollapsed);
    useEffect(() => {
        if (leftNavCollapsed !== defaultLeftSidebarCollapsed) {
            setLeftNavCollapsed(defaultLeftSidebarCollapsed);
        }
    }, [defaultLeftSidebarCollapsed]);
    useEffect(() => {
        if (rightNavCollapsed !== defaultRightSidebarCollapsed) {
            setRightNavCollapsed(defaultRightSidebarCollapsed);
        }
    }, [defaultRightSidebarCollapsed]);
    useEffect(() => {
        !!onSidebarChange && onSidebarChange('left', leftNavCollapsed);
    }, [leftNavCollapsed]);
    useEffect(() => {
        !!onSidebarChange && onSidebarChange('right', rightNavCollapsed);
    }, [rightNavCollapsed]);
    useEffect(() => {
        if (!!defaultNavCollapsed) {
            setNavCollapsed(true);
        }
    }, [defaultNavCollapsed]);
    useEffect(() => {
        if (typeof document !== 'undefined') {
            if (!!tabTitle) {
                document.title = `${tabTitle} | ${t(`appsNames|${app}`)}`;
            }
            else if ((typeof title === 'string' || title instanceof String) &&
                !!title) {
                document.title = `${title} | ${t(`appsNames|${app}`)}`;
            }
            else {
                document.title = t(`appsNames|${app}`);
            }
        }
    }, [tabTitle, title]);
    const containerProps = {
        className,
        cap: app === 'admin' ? theme.caps.xl : theme.caps.normal,
        styles: Object.assign(Object.assign({}, styles), { container: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.container), { position: 'relative' }) }),
        noPadding: true,
        app,
    };
    return (_jsx(PremiumFeatureOverlay, { children: _jsxs(PageContainer, Object.assign({}, containerProps, { icons: [
                {
                    side: 'right',
                    icon: 'Group1Filled',
                    color: theme.colors.beige_1,
                    top: 300,
                    margin: -300,
                    width: 900,
                    height: 800,
                },
            ], styles: {
                container: { height: '100vh', minHeight: 0 },
                content: {
                    position: 'relative',
                    gap: 0,
                    height: '100vh',
                    minHeight: 0,
                    overflow: 'hidden',
                    justifyContent: 'flex-start',
                },
            }, noFooter: noFooter, children: [!!(underSearch || actions) && (_jsxs(Div, { backgroundColor: theme.colors.beige_1, justify: "flex-end", bordersSide: "bottom", borderColor: theme.colors.grey_5, flex: "row", align: "center", gap: theme.spacing.md, style: Object.assign({ paddingBlock: theme.spacing.sm, paddingInline: theme.spacing.xl }, ((_b = styles === null || styles === void 0 ? void 0 : styles.underSearch) !== null && _b !== void 0 ? _b : {})), children: [underSearch, actions] })), _jsxs(SidebarPageContent, { children: [_jsx(SidebarPageSider, { sidebarBlocks: leftSidebarBlocks, isCollapsed: leftNavCollapsed, side: "left", handleCollapse: handleLeftNavCollapsed }), _jsx(SidebarPageBody, { id: "sidebar-page-body", style: Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.body), children: children }), _jsx(SidebarPageSider, { sidebarBlocks: rightSidebarBlocks, isCollapsed: rightNavCollapsed, side: "right", handleCollapse: handleRightNavCollapsed })] })] })) }));
};
export default SidebarPageLayoutV2;
